module.exports = __webpack_public_path__ + "img/machine.345ea2ee.png";